export const BASEURL = process.env.REACT_APP_STAGE === 'dev' ? 'http://localhost:3000' : 'https://api.tw-population.click'
